var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.node.cssClasses},[_c('PlansBenchmark',{attrs:{"content":_vm.content,"inverted":_vm.inverted,"custom-classes":'[&>div]:pt-5',"editorial":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }